var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 3,
    viewBox: "0 0 14 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5037 3C11.6763 3 11 2.3295 11 1.5C11 0.6705 11.6628 0 12.4888 0H12.5037C13.3312 0 14 0.6705 14 1.5C14 2.3295 13.3312 3 12.5037 3",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00299 3C6.17515 3 5.5 2.3295 5.5 1.5C5.5 0.6705 6.16168 0 6.98952 0H7.00299C7.83084 0 8.5 0.6705 8.5 1.5C8.5 2.3295 7.83084 3 7.00299 3",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50374 3C0.676309 3 0 2.3295 0 1.5C0 0.6705 0.662843 0 1.49027 0H1.50374C2.33117 0 3 0.6705 3 1.5C3 2.3295 2.33117 3 1.50374 3",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.eec7e4ff2dc89547fac6f4c88679ab7b.svg";
export { ForwardRef as ReactComponent };